import { render, staticRenderFns } from "./KnowMoreSection.vue?vue&type=template&id=f9c917c0&"
import script from "./KnowMoreSection.vue?vue&type=script&lang=js&"
export * from "./KnowMoreSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports